import { createAPI } from '@/request.js'
// 查询资源
export const permissionQuery = data => createAPI('/api/sys/permission/query.mt', 'post', data)
// 新增资源
export const permissionInsert = data => createAPI('/api/sys/permission/insert.mt', 'post', data)
// 修改资源
export const permissionUpdate = data => createAPI('/api/sys/permission/update.mt', 'post', data)
// 获取资源
export const permissionGet = data => createAPI('/api/sys/permission/get.mt', 'post', data)
// 删除资源
export const permissionDelete = data => createAPI('/api/sys/permission/delete.mt', 'post', data)

// 查询角色
export const roleQuery = data => createAPI('/api/sys/role/query.mt', 'post', data)
// 新增角色
export const roleInsert = data => createAPI('/api/sys/role/insert.mt', 'post', data)
// 修改角色
export const roleUpdate = data => createAPI('/api/sys/role/update.mt', 'post', data)
// 获取角色
export const roleGet = data => createAPI('/api/sys/role/get.mt', 'post', data)
// 删除角色
export const roleDelete = data => createAPI('/api/sys/role/delete.mt', 'post', data)

// 变更角色权限
export const rolePermissionBinding = data => createAPI('/api/sys/role/permission/binding.mt', 'post', data)
// 获得角色权限
export const rolePermissionList = data => createAPI('/api/sys/role/permission/query.mt', 'post', data)

// 查询用户
export const userQuery = data => createAPI('/api/sys/user/query.mt', 'post', data)
// 新增用户
export const userInsert = data => createAPI('/api/sys/user/insert.mt', 'post', data)
// 修改用户
export const userUpdate = data => createAPI('/api/sys/user/update.mt', 'post', data)
// 获取用户
export const userGet = data => createAPI('/api/sys/user/get.mt', 'post', data)
// 删除用户
export const userDelete = data => createAPI('/api/sys/user/delete.mt', 'post', data)
// 重置用户密码
export const userReset = data => createAPI('/api/sys/user/password/reset.mt', 'post', data)
// 封解禁用户
export const userState = data => createAPI('/api/sys/user/state/update.mt', 'post', data)

// 变更用户角色
export const userRoleBinding = data => createAPI('/api/sys/user/role/binding.mt', 'post', data)
// 获得用户角色
export const userRoleList = data => createAPI('/api/sys/user/role/query.mt', 'post', data)

// 刷新
export const reload = data => createAPI('/api/sys/user/authority/reload.mt', 'post', data)
